import { LDFeatureKey } from '@@core/services/launch-darkly.service';

export interface LandingPage {
	name: string;
	value: string;
	route: string;
	featureFlag?: LDFeatureKey;
	queryParams?: Record<string, string>;
}

export enum LandingPageValue {
	Tga = 'tga',
	Dashboard = 'dashboard',
	CoverageDashboard = 'dashboard_v2',
	QualityAnalytics = 'quality_analytics',
	TestOptimization = 'test_optimization',
	MultiAppCoverage = 'multi_app_coverage',
}

export const LandingPages: Record<string, LandingPage> = {
	[LandingPageValue.Tga]: {
		name: 'TGA',
		value: LandingPageValue.Tga,
		route: '/tga',
	},
	// will be use once multi app coverage is open for all
	// or once we support features flag usage for landing page selection
	[LandingPageValue.MultiAppCoverage]: {
		name: 'Multi-App Coverage',
		value: LandingPageValue.MultiAppCoverage,
		featureFlag: LDFeatureKey.MULTI_APP_COVERAGE,
		route: '/coverage-reports/multi-app-coverage',
	},
	[LandingPageValue.CoverageDashboard]: {
		name: 'Coverage Dashboard',
		value: LandingPageValue.CoverageDashboard,
		route: '/dashboard/v2',
	},
	[LandingPageValue.QualityAnalytics]: {
		name: 'Quality Analytics',
		value: LandingPageValue.QualityAnalytics,
		route: '/quality-analytics',
	},
	[LandingPageValue.TestOptimization]: {
		name: 'Test Optimization',
		value: LandingPageValue.TestOptimization,
		route: '/tia/v3',
	},
};
